<!-- 注册页面 -->
<template>
    <div>
        <div class="login-cont">
            <div class="cont-2">
                <div class="col-2 registe">
                    <p class="title">修改密码</p>
                    <p class="pwd-tips">
                        <i class="el-icon-warning"></i>
                        <template v-if="$route.query.passwordStrength == '1'">您的密码存在风险，为了您的账号安全，请更改密码!</template>
                        <template v-if="$route.query.passwordStrength == '2'">为了您的账号安全，请定期更改密码!</template>
                    </p>
                    <!-- 表单 -->
                    <div class="form-box">
                        <el-form :model="form" ref="form" :rules="rules" label-width="0px" class="login-form" @submit.native.prevent>
                            <el-form-item prop="userName">
                                <el-input type="text" v-model.trim="form.userName" placeholder="请输入账号" clearable autocomplete="on"></el-input>
                            </el-form-item>
                            <el-form-item prop="oldPwd">
                                <el-input type="password" placeholder="原密码" v-model="form.oldPwd" 
                                    clearable show-password></el-input>
                            </el-form-item>
                            <el-form-item prop="newPwd">
                                <el-input type="password" placeholder="新密码(8-20位大小字母、数字、符号组合)" v-model="form.newPwd"
                                    clearable show-password></el-input>
                            </el-form-item>
                            <el-form-item prop="confirmPwd">
                                <el-input type="password" placeholder="确认密码" v-model="form.confirmPwd"
                                    clearable show-password></el-input>
                            </el-form-item>
                            <div class="btn-not-change">
                                <span @click="notChange()">暂不修改</span>
                            </div>
                            <div class="login-btn">
                                <el-button type="primary" native-type="submit" @click="submitForm()" :disabled="
                                    !form.userName ||
                                    !form.oldPwd ||
                                    !form.newPwd ||
                                    !form.confirmPwd
                                ">修改密码
                                </el-button>
                            </div>
                        </el-form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import loginApi from '@/resources/loginModule/login';
import config from '@/config';

export default {
    data() {
        // 验证密码
        let checkPwd = (rule, value, callback) => {
            let reg = /^(?![0-9]+$)(?![a-z]+$)(?![A-Z]+$)(?!([^(0-9a-zA-Z)]|[\\(\\)])+$)([^(0-9a-zA-Z)]|[\\(\\)]|[a-z]|[A-Z]|[0-9]){8,20}$/;
            if (!value) {
                return callback(new Error('请输入新密码'));
            } else if (!reg.test(value)) {
                return callback(new Error('8-20位大小字母、数字、符号组合'));
            } else {
                callback();
            }
        };
        let checkConfirmPwd = (rule, value, callback) => {
            if (!value) {
                return callback(new Error('请再次输入密码'));
            } else if (value !== this.form.newPwd) {
                return callback(new Error('两次密码输入不一致'));
            } else {
                callback();
            }
        };
        return {
            // 表单数据
            form: {
                userName: this.$route.query.userName || '',
                oldPwd: '',
                newPwd: '',
                confirmPwd: '',
            },
            //校验
            rules: {
                userName: [{ required: true, message: '请输入账号', trigger: 'blur' }],
                oldPwd: [{ required: true, message: '请输入原密码', trigger: 'blur' }],
                newPwd: [{ required: true, validator: checkPwd, trigger: 'blur' }],
                confirmPwd: [{ required: true, validator: checkConfirmPwd, trigger: 'blur' }],
            }
        };
    },
    created() {

    },
    methods: {
        // 手机号注册
        submitForm() {
            this.$refs.form.validate((valid) => {
                if (valid) {
                    let params = {
                        oldPassword: this.form.oldPwd,
                        newPassword: this.form.newPwd,
                        repeatPassword: this.form.confirmPwd
                    };
                    loginApi.changePassword(params).then((res) => {
                        if (res.returnCode === 200) {
                            this.$message.success('修改成功！');
                            this.$router.push('/web/login');
                        }
                    });
                } else {
                    return false;
                }
            });
        },
        notChange() {
            this.sendMessageToParent(JSON.parse(sessionStorage.userInfo));
        },
        // 跨域通信方法
        sendMessageToParent(data) {
            let originPort = sessionStorage.originPort;
            let originUrl2 = 'http://localhost:' + originPort;
            let originUrl = this.originUrl || sessionStorage.originUrl;
            try {
                parent.postMessage(data, originUrl);
            } catch (e) {
                console.log(e);
            }
            try {
                parent.postMessage(data, originUrl2);
            } catch (e) {
                console.log(e);
            }
        },
    }
}
</script>

<style scoped>
@import "../../../assets/css/login/login.css";
.pwd-tips{
    margin: 0 -20px -10px -10px;
    color: #666;
}
.pwd-tips .el-icon-warning{
    margin-right: 5px;
    margin-top: -2px;
    vertical-align: middle;
    font-size: 18px;
    color: #E6A23C;
}
.btn-not-change{
    margin-top: -5px;
    text-align: right;
    color: #666;
}
.btn-not-change span{
    cursor: pointer;
    color: #999;
}
.btn-not-change span:hover{
    color: #1890ff;
}
</style>
